import { orderBy, slice } from "lodash-es";
import firebase from "firebase/app";
import "firebase/database";
import router from "@/router";

const calculateTransactions = (transactions, type) => {
  let sum = 0;

  if (!type) {
    return sum;
  }

  for (let transaction of transactions) {
    if (transaction.type === type) {
      sum += transaction.amount;
    }
  }
  return sum;
};

const storeTransaction = async (transaction, userId) => {
  return firebase
    .database()
    .ref("users/" + userId + "/transactions")
    .push(transaction);
};

const updateTransaction = (transaction, key) => {
  return new Promise(resolve => {
    transaction.id = key;
    resolve(transaction);
  });
};

const state = {
  transactions: [],
  currentPage: 1,
  visibleItemsPerPageCount: 0,
  startDate: "",
  endDate: ""
};

const mutations = {
  resetAllTransactions(state) {
    state.transactions = [];
  },
  addTransaction(state, payload) {
    if (state.startDate <= payload.date && payload.date <= state.endDate) {
      state.transactions.push(payload);
    }
  },
  editTransaction(state, payload) {
    const index = state.transactions.findIndex(obj => {
      return obj.id === payload.id;
    });
    state.transactions.splice(index, 1, payload);
  },
  deleteTransaction(state, payload) {
    const index = state.transactions.findIndex(child => {
      return child.id === payload;
    });

    state.transactions.splice(index, 1);
  },
  setInitialItemsPerPage(state, payload) {
    state.visibleItemsPerPageCount = payload;
  },
  setPaginationOptions(state, payload) {
    state.currentPage = payload.currentPage;
    state.visibleItemsPerPageCount = payload.visibleItemsPerPageCount;
  },
  setPeriod(state, payload) {
    state.startDate = payload.startDate;
    state.endDate = payload.endDate;
  },
  openTransaction(state, payload) {
    state.transactions.forEach(obj => {
      obj.open = obj.id === payload.id ? true : false;
    });
  },
  closeTransaction(state, payload) {
    const index = state.transactions.findIndex(obj => {
      return obj.id === payload.id;
    });
    state.transactions[index].open = false;
  }
};

const actions = {
  resetAllTransactions({ commit }) {
    commit("resetAllTransactions");
  },
  getTransactions({ commit }, payload) {
    commit("setLoading", true);

    const userId = payload.userId;

    let today = new Date();
    today.setUTCHours(0, 0, 0, 0);

    const startDate = payload.startDate ? payload.startDate : payload.taxDate;
    const endDate = payload.endDate ? payload.endDate : today.toISOString();

    commit("setPeriod", { startDate, endDate });

    let ref = firebase.database().ref("users/" + userId + "/transactions");

    ref
      .orderByChild("date")
      .startAt(startDate)
      .endAt(endDate)
      .once("value")
      .then(snapshot => {
        let data = snapshot.val();
        // console.log(data);
        if (data && Object.keys(data).length > 0) {
          Object.keys(data).forEach(key => {
            let transaction = data[key];
            transaction.id = key;
            commit("addTransaction", transaction);
          });
        }

        commit("setLoading", false);
        router.push("/");
      });
  },
  async addTransaction({ commit }, payload) {
    commit("setLoading", true);
    commit("clearError");

    let transaction = {
      amount: payload.amount,
      date: payload.date,
      description: payload.description,
      type: payload.type,
      open: false,
      createdAt: payload.createdAt,
      updatedAt: payload.updatedAt
    };

    let arr = [];
    for (let i = 0; i < payload.paymentsNumber; i++) {
      arr.push(i);
    }

    for (let i of arr) {
      let newTrans = Object.assign({}, transaction);
      let stored = await storeTransaction(transaction, payload.userId);
      let changed = await updateTransaction(newTrans, stored.key);
      commit("addTransaction", changed);
    }

    const alert =
      arr.length > 1
        ? "Transactions have been successfully added"
        : "Transaction has been successfully added";

    commit("setLoading", false);
    commit("setMessage", { role: "success", message: alert });
  },
  editTransaction({ commit }, payload) {
    commit("setLoading", true);
    commit("clearError");

    let transaction = {
      amount: payload.amount,
      date: payload.date,
      description: payload.description,
      paymentsNumber: payload.paymentsNumber,
      type: payload.type,
      createdAt: payload.createdAt,
      updatedAt: payload.updatedAt
    };

    firebase
      .database()
      .ref("users/" + payload.userId + "/transactions")
      .child(payload.id)
      .update(transaction)
      .then(data => {
        console.log(data);
        transaction.id = payload.id;
        transaction.open = false;

        commit("editTransaction", transaction);
        commit("setLoading", false);
      })
      .catch(error => {
        commit("setError", error);
        commit("setLoading", false);
        console.log(error);
      });
  },
  deleteTransaction({ commit }, payload) {
    commit("setLoading", true);

    firebase
      .database()
      .ref("users/" + payload.userId + "/transactions")
      .child(payload.transactionId)
      .remove()
      .then(() => {
        commit("deleteTransaction", payload.transactionId);
        commit("setLoading", false);
        router.push("/");
      })
      .catch(error => {
        console.log(error);
        commit("setLoading", false);
      });
  },
  setInitialItemsPerPage({ commit }, payload) {
    commit("setInitialItemsPerPage", payload);
  },
  getPaginatedTransactions({ commit }, payload) {
    commit("setPaginationOptions", payload);
  },
  openTransaction({ commit }, payload) {
    commit("openTransaction", payload);
  },
  closeTransaction({ commit }, payload) {
    commit("closeTransaction", payload);
  }
};

const getters = {
  transactions(state) {
    if (state.transactions.length > 0) {
      let transactions = orderBy(state.transactions, ["date"], ["desc"]);
      return transactions;
    } else {
      return [];
    }
  },
  numberOfTransactions(state) {
    return state.transactions.length;
  },
  paginatedTransactions(state) {
    let transactions = orderBy(state.transactions, ["date"], ["desc"]);
    let count = state.visibleItemsPerPageCount;
    const startIndex = state.visibleItemsPerPageCount * (state.currentPage - 1);
    const endIndex = startIndex + count;

    return slice(transactions, [startIndex], [endIndex]);
  },
  income(state) {
    return calculateTransactions(state.transactions, "income");
  },
  outcome(state) {
    return calculateTransactions(state.transactions, "outcome");
  },
  startDate(state) {
    return state.startDate;
  },
  endDate(state) {
    return state.endDate;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
